import React from 'react';
import { useApp } from '../context/AppContext';
import SolarSystem from '../components/galaxy/SolarSystem';
import { motion } from 'framer-motion';

const GalaxyView = () => {
  const { galaxyData } = useApp();

  return (
    <div className="min-h-screen pt-16 relative overflow-hidden galaxy-bg">
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/50 via-transparent to-slate-950/80 pointer-events-none" />
      
      <div className="relative z-10 container mx-auto px-4 py-12">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-[10px] font-black text-blue-500 uppercase tracking-[0.4em] mb-4"
          >
            Maysalward Ecosystem
          </motion.div>
          <motion.h1
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="text-4xl md:text-6xl font-black bg-clip-text text-transparent bg-gradient-to-r from-blue-300 via-purple-300 to-pink-300 mb-6"
          >
            The Capsule Universe
          </motion.h1>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg">
            Explore the constellations of contribution within the Maysalward community. Each system represents an entity shining brighter with every verified impact.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 place-items-center">
          {galaxyData.map((user, idx) => (
            <motion.div
              key={user.id}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: idx * 0.1 }}
              className="p-8 rounded-full hover:bg-white/5 transition-colors duration-500 cursor-pointer"
            >
              <SolarSystem user={user} />
            </motion.div>
          ))}

          {galaxyData.length === 0 && (
            <div className="col-span-full text-center py-20 text-slate-500 italic">
              The universe is waiting for its first spark...
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GalaxyView;